import React from 'react';

const PrintHeaderExamen = ({ etablissement, examen }) => {
  return (
    <div className="hidden print:block print:mb-6">
      {/* En-tête administratif */}
      <div className="pb-2 print:border-b-0">
        {/* En-tête supérieur */}
        <div className="flex justify-between items-start mb-2">
          {/* Logo à gauche */}
          {(etablissement?.logo || etablissement?.logo_url) && (
            <div className="w-[15%] flex-shrink-0">
              <img 
                src={etablissement.logo || etablissement.logo_url} 
                alt="Logo de l'établissement" 
                className="object-contain max-h-20"
              />
            </div>
          )}
          
          {/* Textes au centre */}
          <div className="w-[70%] text-center">
            <p className="text-sm font-bold uppercase mb-0.5">
              RÉPUBLIQUE {etablissement?.pays ? `DU ${etablissement.pays.toUpperCase()}` : ''}
            </p>
            <div className="w-24 h-0.5 bg-black mx-auto mb-0.5"></div>
            {etablissement?.ministere && (
              <p className="text-xs uppercase mb-1">
                MINISTÈRE DE {etablissement.ministere.toUpperCase()}
              </p>
            )}
            <h1 className="text-xl font-bold mb-0.5">
              {etablissement?.libelle || etablissement?.nom || 'Établissement'}
            </h1>
            <p className="text-sm italic mb-1">
              {etablissement?.devise || 'Excellence et Savoir'}
            </p>
            <div className="flex justify-center items-center text-xs flex-wrap">
              <span>Email: {etablissement?.email || 'N/A'}</span>
              <span className="mx-1">|</span>
              <span>Contact: {etablissement?.contact || etablissement?.telephone || 'N/A'}</span>
              <span className="mx-1">|</span>
              <span>BP: {etablissement?.bp || 'N/A'}</span>
              {(etablissement?.site_web || etablissement?.website) && (
                <>
                  <span className="mx-1">|</span>
                  <span>Site: {etablissement?.site_web || etablissement?.website}</span>
                </>
              )}
            </div>
            <p className="text-xs">{etablissement?.adresse || 'Adresse non spécifiée'}</p>
          </div>
          
          {/* Année académique à droite */}
          <div className="w-[15%] flex-shrink-0 text-right">
            <div className="inline-block print:border-0 border border-[#202654] rounded p-1 text-center">
              <p className="text-xs mb-0.5">Année Académique</p>
              <p className="text-sm font-bold">{examen?.annee?.libelle || 'N/A'}</p>
            </div>
          </div>
        </div>
        
        {/* Titre du document */}
        <div className="text-center mt-4 mb-6">
          <h2 className="text-xl font-bold tracking-wider inline-block print:border-0 border border-[#202654] py-1 px-4">
            FICHE D'EXAMEN
          </h2>
          <h3 className="text-lg font-semibold mt-2">
            {examen?.libelle || 'Examen'}
          </h3>
          <h4 className="text-base mt-1">
            {examen?.semestre?.libelle ? `Semestre: ${examen.semestre.libelle}` : ''}
          </h4>
        </div>
      </div>
    </div>
  );
};

export default PrintHeaderExamen; 